import React from "react";

// SSG Peak / chevron mark — silver with red top wedge.
// Matches the alternate SSG logo mark.
export const PeakMark = ({ size = 32, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="square"
    strokeLinejoin="miter"
    className={className}
    aria-hidden="true"
  >
    <path d="M8 40 L32 12 L56 40" stroke="#E25555" />
    <path d="M8 52 L32 24 L56 52" stroke="currentColor" />
  </svg>
);

export default PeakMark;
